import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { ProofCard } from "@/components/ProofCard";
import { Reveal } from "@/components/Reveal";
import { PreviewTag } from "@/components/kit";
import { demoProofs } from "@/data/demoProofs";

export const Proof = () => {
    const [query, setQuery] = useState("");

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return demoProofs;
        return demoProofs.filter(
            (p) =>
                p.proofId.toLowerCase().includes(q) ||
                p.task.toLowerCase().includes(q) ||
                p.taskId.toLowerCase().includes(q) ||
                p.agent.toLowerCase().includes(q) ||
                p.hash.toLowerCase().includes(q),
        );
    }, [query]);

    return (
        <>
            <PageHeader
                index="04"
                eyebrow="PROOF EXPLORER"
                title={<>PROVE WHAT<br /><span className="text-[#1677FF]">HAPPENED.</span></>}
                description="Search by Task ID, Agent ID, Proof ID or Proof Hash. Every proof carries its evidence record and settlement state."
            >
                <div className="mt-8">
                    <PreviewTag>SIMULATION — PRE-LAUNCH DATA</PreviewTag>
                </div>
            </PageHeader>

            <section className="section">
                <div className="shell">
                    <Reveal>
                        <div className="relative max-w-2xl">
                            <Search size={16} className="absolute left-5 top-1/2 -translate-y-1/2 text-mute" aria-hidden="true" />
                            <input
                                data-testid="proof-search-input"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                placeholder="SEARCH: TASK ID / AGENT ID / PROOF ID / PROOF HASH"
                                aria-label="Search proofs"
                                className="w-full border border-white/10 bg-[#0A1627] py-4 pl-12 pr-5 font-mono text-xs uppercase tracking-[0.14em] text-ink placeholder:text-mute/50 transition-colors duration-300 focus:border-[#1677FF] focus:outline-none"
                            />
                        </div>
                    </Reveal>

                    <div className="mt-10 space-y-5" data-testid="proof-search-results">
                        {filtered.length === 0 ? (
                            <div className="border border-dashed border-white/10 p-16 text-center">
                                <p className="font-mono text-xs uppercase tracking-[0.24em] text-mute">
                                    NO PROOF MATCHES "{query}" — PROTOCOL PREVIEW CONTAINS 4 DEMO PROOFS
                                </p>
                            </div>
                        ) : (
                            filtered.map((p, i) => (
                                <Reveal key={p.proofId} delay={Math.min(i * 0.06, 0.3)}>
                                    <ProofCard proof={p} />
                                </Reveal>
                            ))
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Proof;
